import { render, staticRenderFns } from "./workbenchContent.vue?vue&type=template&id=420120ae&scoped=true"
import script from "./workbenchContent.vue?vue&type=script&lang=js"
export * from "./workbenchContent.vue?vue&type=script&lang=js"
import style0 from "./workbenchContent.vue?vue&type=style&index=0&id=420120ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420120ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420120ae')) {
      api.createRecord('420120ae', component.options)
    } else {
      api.reload('420120ae', component.options)
    }
    module.hot.accept("./workbenchContent.vue?vue&type=template&id=420120ae&scoped=true", function () {
      api.rerender('420120ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/workbenchContent.vue"
export default component.exports